import React, { Component } from "react";

import "../../styles/components/Dynamic/DynamicTable.css";
import { Table } from "antd";

class DynamicTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: this.props.columns,
      data: this.props.data
    };
  }

  componentWillMount() {
    this.setState({
      columns: this.props.columns,
      data: this.props.data
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      columns: nextProps.columns,
      data: nextProps.data
    });
  }

  render() {
    return (
      <div className="TableParent">
        <Table
          locale={{ emptyText: "Ska Akte" }}
          className="Table"
          columns={this.state.columns}
          pagination={{ pageSize: 10, size: "small" }}
          dataSource={this.state.data}
        />
      </div>
    );
  }
}
export default DynamicTable;
